module.exports = __webpack_public_path__ + "img/moneymex_scroll02.a509e6a9.webp";